import { ImagesType, RebateOrOfferType } from '../..';
import Rebate from './rebate';

type RebateListProps = {
  rebates: RebateOrOfferType[];
  setSelectedOffer: React.Dispatch<React.SetStateAction<RebateOrOfferType | undefined>>;
  setIntersectingCardIndex: React.Dispatch<React.SetStateAction<number>>;
  intersectingCardIndex: number;
  indexAdjustment: number;
  btn: string;
  images?: ImagesType;
};

const RebateList = ({
  rebates,
  setSelectedOffer,
  intersectingCardIndex,
  setIntersectingCardIndex,
  indexAdjustment,
  btn,
}: RebateListProps) => {
  const shouldAdjustRowLayout = rebates.length > 3 && rebates.length % 2 === 0;
  return (
    <>
      {rebates.map((rebate, index) => {
        const i = index + indexAdjustment;
        let shouldAdjustRow = false;
        if (shouldAdjustRowLayout && index === 0) {
          shouldAdjustRow = true;
        }
        return (
          <Rebate
            rebate={rebate}
            setSelectedOffer={setSelectedOffer}
            isPrimary={index === 0}
            key={index}
            shouldAdjustRow={shouldAdjustRow}
            shouldZoom={intersectingCardIndex === i}
            setIntersection={() => setIntersectingCardIndex(i)}
            btn={btn}
          />
        );
      })}
    </>
  );
};

export default RebateList;
export type { RebateListProps };
